import sessionDB from './sessionDB';
import { API_BASE_URL } from '../api/config';
export const SESSION_EXPIRED_EVENT = 'session-expired';
let pendingToken = null;
export const isSessionExpiring = token => pendingToken === token;
export async function expireSession(token) {
  if (!token || sessionDB.getAccessToken() !== token || pendingToken === token) return;
  pendingToken = token;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    await fetch((API_BASE_URL || '').replace(/\/+$/, '') + '/saas/login/logout', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken: sessionDB.getRefreshToken() }), signal: controller.signal,
    });
  } catch {
    // Always sign out locally, even if the logout endpoint is unavailable.
  } finally {
    clearTimeout(timeout);
    if (sessionDB.getAccessToken() === token) {
      sessionDB.clearSession();
      window.dispatchEvent(new Event('hrms-logout'));
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }
    if (pendingToken === token) pendingToken = null;
  }
}
export function installSessionExpiryHandler() {
  const originalFetch = window.fetch;
  window.fetch = async (input, options) => {
    const token = sessionDB.getAccessToken();
    const headers = new Headers(options?.headers ?? (input instanceof Request ? input.headers : undefined));
    const authenticated = token && headers.get('Authorization') === 'Bearer ' + token;
    const response = await originalFetch.call(window, input, options);
    if (authenticated && !response.ok) {
      let data;
      try { data = await response.clone().json(); } catch { /* Preserve non-JSON responses. */ }
      if (typeof data?.message === 'string' && /^session expired\.\s*please re-login\.?$/i.test(data.message.trim())) {
        await expireSession(token);
      }
    }
    return response;
  };
}